<div class="row">
    <div id="logo" class="col-lg-6 col-md-6 col-xs-12">
        <img src="./assets/images/encuesta-calida-woden.jpg" alt="User Image" id="back-ground">
        <div class=" slid2">
            <div class="gracias">
                <p>!Tu opinión</p>
                <p>es lo más importante</p>
                <p>para nosotros!</p>
                <div id="lineFeed"></div>
            </div>
            <div class="logowoden">
                <img src="../assets/images/logo woden 2018 blanco.png" alt="">
            </div>
        </div>
    </div>
    <div class="col-lg-6 col-md-6 col-xs-12">
        <div id="form">
            <div id="line"></div>
            <h2><strong>¡Ayúdanos a mejorar!</strong></h2>
            <h4>Tu opinión es lo más importante para nosotros. Déjanos saber cómo fue tu experiencia con el servicio WODEN PRO, respondiendo 5 simples preguntas:</h4>
            <div class="clearfix colelem"></div>
            <h4>¿Lograste tu objetivo?</h4>
            <form #encuestaForm="ngForm" name="encuestaForm">
                <div class="row form-group form-inline">
                    <div class="col-md-3 col-xs-2">
                        <input class="wrapped-input" type="radio" #eco="ngModel" name="eco" [(ngModel)]="encuesta.objective" value="si" required><span class="spanl">Si</span>
                    </div>
                    <div class="col-md-3 col-xs-2">
                        <input class="wrapped-input" type="radio" #eco="ngModel" name="eco" [(ngModel)]="encuesta.objective" value="no" required><span class="spanl">No</span>
                    </div>
                    <div class="col-md-4 col-xs-4">
                        <input class="wrapped-input" type="radio" #eco="ngModel" name="eco" [(ngModel)]="encuesta.objective" value="parcialmente" required><span class="spanl">Parcialmente</span>
                    </div>
                </div>
                <div class="fld-grp clearfix grpelem">
                    <textarea class="fld-textarea" placeholder="¿Qué faltó para lograras tu objetivo?" #ecot="ngModel" name="ecot" [(ngModel)]="encuesta.objectiveText" required></textarea>
                </div>
                <h4>Del 1 al 5, ¿qué tan fácil fue todo el proceso?</h4>
                <div class="row form-group form-inline">
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #ecf="ngModel" name="ecf" [(ngModel)]="encuesta.facility" value="1" required><span class="spanl">1</span>
                    </div>
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #ecf="ngModel" name="ecf" [(ngModel)]="encuesta.facility" value="2" required><span class="spanl">2</span>
                    </div>
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #ecf="ngModel" name="ecf" [(ngModel)]="encuesta.facility" value="3" required><span class="spanl">3</span>
                    </div>
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #ecf="ngModel" name="ecf" [(ngModel)]="encuesta.facility" value="4" required><span class="spanl">4</span>
                    </div>
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #ecf="ngModel" name="ecf" [(ngModel)]="encuesta.facility" value="5" required><span class="spanl">5</span>
                    </div>
                </div>
                <h4>Del 1 al 5, ¿cómo califica la actitud y disposición de nuestro personal durante todo el proceso?</h4>
                <div class="row form-group form-inline">
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #eca="ngModel" name="eca" [(ngModel)]="encuesta.personnel" value="1" required><span class="spanl">1</span>
                    </div>
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #eca="ngModel" name="eca" [(ngModel)]="encuesta.personnel" value="2" required><span class="spanl">2</span>
                    </div>
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #eca="ngModel" name="eca" [(ngModel)]="encuesta.personnel" value="3" required><span class="spanl">3</span>
                    </div>
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #eca="ngModel" name="eca" [(ngModel)]="encuesta.personnel" value="4" required><span class="spanl">4</span>
                    </div>
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #eca="ngModel" name="eca" [(ngModel)]="encuesta.personnel" value="5" required><span class="spanl">5</span>
                    </div>
                </div>
                <h4>Del 1 al 5, ¿cómo calificaría su experiencia con nosotros?</h4>
                <div class="row form-group form-inline">
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #ece="ngModel" name="ece" [(ngModel)]="encuesta.experience" value="1" required><span class="spanl">1</span>
                    </div>
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #ece="ngModel" name="ece" [(ngModel)]="encuesta.experience" value="2" required><span class="spanl">2</span>
                    </div>
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #ece="ngModel" name="ece" [(ngModel)]="encuesta.experience" value="3" required><span class="spanl">3</span>
                    </div>
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #ece="ngModel" name="ece" [(ngModel)]="encuesta.experience" value="4" required><span class="spanl">4</span>
                    </div>
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #ece="ngModel" name="ece" [(ngModel)]="encuesta.experience" value="5" required><span class="spanl">5</span>
                    </div>
                </div>
                <h4>En una escala de 0 a 10 ¿qué tan probable es que usted recomiende nuestro servicio a un amigo o colega?</h4>
                <div class="row form-group form-inline">
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #ecr="ngModel" name="ecr" [(ngModel)]="encuesta.recommend" value="1" required><span class="spanl">1</span>
                    </div>
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #ecr="ngModel" name="ecr" [(ngModel)]="encuesta.recommend" value="2" required><span class="spanl">2</span>
                    </div>
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #ecr="ngModel" name="ecr" [(ngModel)]="encuesta.recommend" value="3" required><span class="spanl">3</span>
                    </div>
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #ecr="ngModel" name="ecr" [(ngModel)]="encuesta.recommend" value="4" required><span class="spanl">4</span>
                    </div>
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #ecr="ngModel" name="ecr" [(ngModel)]="encuesta.recommend" value="5" required><span class="spanl">5</span>
                    </div>
                </div>
                <div class="row form-group form-inline">
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #ecr="ngModel" name="ecr" [(ngModel)]="encuesta.recommend" value="6" required><span class="spanl">6</span>
                    </div>
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #ecr="ngModel" name="ecr" [(ngModel)]="encuesta.recommend" value="7" required><span class="spanl">7</span>
                    </div>
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #ecr="ngModel" name="ecr" [(ngModel)]="encuesta.recommend" value="8" required><span class="spanl">8</span>
                    </div>
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #ecr="ngModel" name="ecr" [(ngModel)]="encuesta.recommend" value="9" required><span class="spanl">9</span>
                    </div>
                    <div class="col-md-2 col-xs-2">
                        <input class="wrapped-input" type="radio" #ecr="ngModel" name="ecr" [(ngModel)]="encuesta.recommend" value="10" required><span class="spanl">10</span>
                    </div>
                </div>
                <div style="margin-bottom: 20px;margin-top: 40px;margin-right: 20px;">
                    <button class="btn btn-block" (click)="createEncuesta()" [disabled]="!encuestaForm.form.valid" style="background: #FF7700; color:white; margin-top: 20px;"><b *ngIf="!loading">Enviar</b> 
                <div *ngIf="loading" class="loadlog"></div>
                </button>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-lg-12 footer">
        <div class="col-md-10 col-md-offset-1" style="margin-bottom: 10px;">
            <div class="row form-group">
                <div class="col-xs-6" style="margin-top: 40px;">
                    <h3>Sobre Woden</h3>
                    <p style="font-size: 10px; width: 90%;">
                        Somos aliados de negocio marcas líderes en tecnología y comunicaciones a nivel mundial. Potenciamos el ciclo de vida útil de equipos tecnológicos usados y ofrecemos a personas y empresas una amplia variedad de productos y servicios que hacen la vida mas
                        facil, generan ahorros y ayudan al medio ambiente.
                    </p>
                </div>
                <div class="col-xs-6" style="margin-top: 40px;">
                    <h3 style="margin-left: 22px;">Accesos rápidos</h3>
                    <ul style="font-size: 10px">
                        <li>Sitio Web Woden</li>
                        <li>Tienda online</li>
                        <li>Gestion de orden de servicio</li>
                        <li>Contacto</li>
                        <li>Servicio al cliente</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-12 footer2">
        <div class="col-md-10 col-md-offset-1" style="margin-bottom: 1px;">
            <div class="col-lg-6" style="margin-top: 10px;">
                <strong>WODEN COLOMBIA SAS,</strong>Todos los derchos reservados
            </div>
            <div class="col-lg-3" style="margin-top: 10px;">
                <p style="font-size: 10px;">Avenida calle 13 # 56 - 35 Bogotá, Colombia</p>
            </div>
            <div class="col-lg-3" style="margin-top: 10px;">
                <p style="font-size: 10px;">+57(1)355 8200</p>
            </div>
        </div>
    </div>
    <div class="col-lg-12 footer3">

    </div>
</div>